import { render, staticRenderFns } from "./companyCollectItem.vue?vue&type=template&id=bbbad79c&scoped=true"
import script from "./companyCollectItem.vue?vue&type=script&lang=js"
export * from "./companyCollectItem.vue?vue&type=script&lang=js"
import style0 from "./companyCollectItem.vue?vue&type=style&index=0&id=bbbad79c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbbad79c",
  null
  
)

export default component.exports